// requires password to have 1 uppercase, 1 lowercase, 1 number, and be between 8-32 chars
/// <amd-module name="TFS/Admin/Common/Util/PasswordValidator" />
export const strongRegex: any = new RegExp("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,32}$");
// string cannot start with a digit.
export const cannotStartWithDigit = new RegExp("/^d/");
export const doesNotStartWithDigitAndOnlyAlphanumeric = /^[a-z][a-z0-9]*$/i;
// export const canOnlyContainNumsbersAndDigits = new RegExp('/[,"/\\[]:|<>+=.;?*]/', "g");
